import React, { useEffect } from "react";
import "./Home.css";
import Header from "../Header/Header";
import Spotlight from "../Spotlight/Spotlight";
import Design from "../Design/Design";
import Service from "../Service/Service";
import Work from "../Work/Work";
import About from "../About/About";
import Footer from "../Footer/Footer";
import Projects from "../Projects/Projects";
import LeaderAppIntro from "../LeaderAppIntro/LeaderAppIntro";
import { Helmet } from "react-helmet";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Helmet>
        {/* Primary SEO Meta Tags */}
        <title>Spinecodes | Digital Solutions & App Development</title>
        <meta
          name="description"
          content="Spinecodes delivers expert mobile and web app development, UX/UI design, AI-powered applications, business automation, crowdfunding management, fintech solutions, and political campaign software."
        />
        <meta
          name="keywords"
          content="Mobile App Development, Web Development, UX/UI Design, AI Applications, Business Automation, Crowdfunding Management, Fintech Solutions, Political Campaign Software, Spinecodes, Software Development Kerala,Software Development Malappuram"
        />
        <meta name="author" content="Spinecodes" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.spinecodes.com" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.spinecodes.com" />
        <meta
          property="og:title"
          content="Spinecodes | Custom Digital Solutions & App Development"
        />
        <meta
          property="og:description"
          content="Spinecodes delivers innovative digital solutions and custom app development to help businesses grow through smart, scalable technology."
        />
        <meta
          property="og:image"
          content="https://www.spinecodes.com/favicon.svg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Spinecodes | Digital Solutions & App Development"
        />
        <meta
          name="twitter:description"
          content="Spinecodes delivers expert mobile and web app development, UX/UI design, AI-powered applications, business automation, crowdfunding management, fintech solutions, and political campaign software."
        />
        <meta
          name="twitter:image"
          content="https://www.spinecodes.com/favicon.svg"
        />
        <meta name="twitter:site" content="@SpineCodes" />
        <meta name="twitter:creator" content="@SpineCodes" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Spinecodes",
          "url": "https://www.spinecodes.com",
          "logo": "https://www.spinecodes.com/favicon.svg",
          "sameAs": [
            "https://x.com/SpineCodes",
            "https://www.facebook.com/share/RGjeJ543mEvTNT7c/?mibextid=qi2Omg",
            "https://www.instagram.com/spine_codes/?igsh=MWV3cnBmb210dnoxcg%3D%3D#",
            "https://www.linkedin.com/company/spinecodes/"
          ],
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+91 8547274065",
              "contactType": "customer service",
              "email": "info@spinecodes.com"
            }
          ]
        }
        `}
        </script>
      </Helmet>
      <h1 className="visually-hidden">
        Custom Digital Solutions & App Development by Spinecodes
      </h1>
      <Header />
      <Spotlight />
      {/* <LeaderAppIntro /> */}
      <Design />
      <Service />
      <Work />
      <Projects />
      <About />
      <Footer />
    </div>
  );
}

export default Home;
